<template>
  <div>
    <loader/>
  </div>
</template>

<script>
import Loader from '../components/Loader'
import localStorageHelper from '@/helpers/localStorageHelper'

export default {
  name: 'LogInCallback',
  components: {Loader},
  mounted() {
    if (!this.$route.query) {
    }
    const loginProvider = localStorageHelper.get('loginProvider')
    if (this.$route.query.error) {
      localStorageHelper.set('loginError', this.$route.query.error)
      this.$auth.logout({
        returnTo: window.location.origin
      })
    } else {
        const redirectingTo = localStorage.getItem('targetUrl') ?? '/account'
        if (this.$route.hash && this.$route.hash.indexOf('access_token=') && loginProvider)
        {
          localStorageHelper.set('login_success', redirectingTo)
        }
        window.location.href = redirectingTo
    }
  }
}
</script>

<style>
</style>
